/**
 * @file: NewOrderBody.tsx
 *
 * `OrgNewOrder` — a new vehicle-service order was just authored.
 * Renders the customer + service-subjects at a glance (the thread is
 * already scoped to one order, so the order-no would be redundant).
 */

import { OrgNewOrderFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import { KeyValueGrid, TitleText } from './common/primitives';

export const NewOrderBody: FC<{ p: OrgNewOrderFeedPayload }> = ({ p }) => (
  <View>
    <TitleText>新建工单</TitleText>
    <KeyValueGrid
      items={[
        ['车主', p.customerName ?? null],
        ['服务项目', p.serviceSubjects ?? null],
      ]}
    />
  </View>
);
